import { render, staticRenderFns } from "./towork-not.vue?vue&type=template&id=6f8772e2"
import script from "./towork-not.vue?vue&type=script&lang=js"
export * from "./towork-not.vue?vue&type=script&lang=js"
import style0 from "./towork-not.vue?vue&type=style&index=0&id=6f8772e2&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports